import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _chunk from 'lodash/chunk';
import _capitalize from 'lodash/capitalize';

import { CheckBox } from 'components';

const LIMIT = 5;
const TYPE = 'radio';

export default function FilterSelect({
  items = [],
  type = TYPE,
  name = '',
  onChange,
  isRemovable = true,
}) {
  const [listOfFilters, setListOfFilters] = useState([]);
  const [allFilters, setAllFilters] = useState([]);
  const [currentLength, setCurrentLength] = useState(0);
  const handleClickShowMore = () => {
    const nextLength = currentLength + 1;

    if (allFilters[nextLength]) {
      setListOfFilters((currentListOfFilters) =>
        currentListOfFilters.concat(allFilters[nextLength])
      );

      setCurrentLength(nextLength);
    }
  };

  const handleClickShowLess = () => {
    const nextLength = currentLength;

    if (allFilters[nextLength]) {
      const [firstFilter] = allFilters[nextLength];

      if (!firstFilter) return;

      const { value } = firstFilter;

      const filterData = listOfFilters
        .map((filter, index) => ({
          ...filter,
          index
        }))
        .find((filter) => filter.value === value);

      if (filterData) {
        setListOfFilters((currentListOfFilters) => {
          const newListOfFilters = currentListOfFilters.slice(
            0,
            filterData.index
          );

          return newListOfFilters;
        });
        setCurrentLength((current) => current - 1);
      }
    }
  };

  const handleChange = (...args) => {
    if (onChange) onChange(...args);
  };

  useEffect(() => {
    if (items && items.length > 0) {
      const filtersList = _chunk(items, LIMIT);

      setListOfFilters(filtersList[0]);
      setAllFilters(filtersList);
      setCurrentLength(0);
    }
  }, [items]);

  return (
    <>
      {listOfFilters.map(({ value, label }) => (
        <CheckBox
          key={value}
          type={type}
          label={_capitalize(label)}
          name={name}
          value={value}
          className="p-0"
          containerClassName="p-0"
          removable={isRemovable}
          onChange={handleChange}
        />
      ))}

      {allFilters.length > currentLength + 1 && (
        <div
          
          role="button"
          tabIndex={0}
          onClick={handleClickShowMore}
          onKeyPress={handleClickShowMore}
        >
          <p style={{
            margin: 0,
            padding: 0,
            border: 0,
            font: 'inherit',
            fontSize: '100%',
            verticalAlign: 'baseline',
            textAlign: 'left !important',
            textDecoration: 'underline',
            color: '#2491b4'
          }}>
            Ver más
          </p>
        </div>
      )}

      {listOfFilters.length > LIMIT && (
        <div
          role="button"
          tabIndex={0}
          onClick={handleClickShowLess}
          onKeyPress={handleClickShowLess}
        >
          <p style={{
            margin: 0,
            padding: 0,
            border: 0,
            font: 'inherit',
            fontSize: '100%',
            verticalAlign: 'baseline',
            textAlign: 'left !important',
            textDecoration: 'underline',
            color: '#2491b4'
          }}>
            Ver menos
          </p>
        </div>
      )}
    </>
  );
}

FilterSelect.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isRemovable: PropTypes.bool,
};
